
import { curryFactory, createObserver } from '~/utils/tools.js'
const createObject = curryFactory('title', 'desc', 'targer')

export default {
  name: 'CommonScrollCard',
  props: {
    title: {
      type: String,
      default: '多种考试类型支持',
    },
    align: {
      type: String,
      default: 'left', // left reverse  文字内容占位方式
    },
    // 左侧文字列表
    textList: {
      type: Array,
      default: null,
    },
    // 右侧图片相应列表
    images: {
      type: Array,
      default: null,
    },
    scence: {
      type: String,
      default: '考试测评',
    },
  },
  data() {
    return {
      active: '',
      defList: {
        考试测评: [
          createObject('企业考试', '培训考试、业务技能考察、文化制度测试'),
          createObject('学科考试', '语文、数学、英语、政治、地理、历史、物理、化学、生物...'),
          createObject('在线考试', '趣味测评、心理测评、知识竞赛...'),
        ],
      },
      defImage: {
        考试测评: [
          require('~/assets/image/scence/assess/scroll01.png'),
          require('~/assets/image/scence/assess/scroll02.png'),
          require('~/assets/image/scence/assess/scroll03.png'),
        ],
      },
    }
  },
  computed: {
    mapList() {
      return this.defList[this.scence]
    },
    mapImgs() {
      return this.defImage[this.scence]
    },
    isMobile() {
      return this.$store.state.isMobile
    },
  },
  mounted() {
    this.$nextTick(() => this.init())
  },
  methods: {
    init() {
      if (!this.$refs?.image?.length || this.isMobile) return
      const obser = createObserver({
        threshold: [0, 0.5, 1],
      })
      this.$refs.image.forEach((item, index) => {
        obser.add(item.$el).then((status, { intersectionRatio }) => {
          if (intersectionRatio === 1) this.active = index
        })
      })
    },
    clickTest() {
      const {
        isMobile,
        isHandset,
        isPad: curPad,
        mediaType: { isMobile: _ismmobile, isPad },
      } = this.$store.state
      console.log(isMobile, isHandset, _ismmobile, isPad, 'curPad', curPad)
    },
  },
}
